module.exports = __webpack_public_path__ + "img/box-skins-blue2.7cfeb9c8.jpg";